<template>
  <div id="nPrintingPageTable" class="print-list_box">
    <div class="yto-box yto-box-pb" style="padding:8px 10px;">
      <el-form :inline="true" :model="form" ref="ruleForm">
        <div class="y-f y-f-a">
          <div>
            <el-form-item label="" prop="mailNoList" class="textarea-style" label-width="0">
              <el-input
              type="textarea"
              :rows="4"
              resize="none"
              placeholder="请输入单号，最多100个，请用，或者换行隔开"
              v-model.trim="form.mailNoList"
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item prop="createTime" label="下单时间">
              <yto-date-picker
                :maxRangeVal="31"
                :customDaysName="`custom_sepecial_${this.curComponent}_customrange`"
                :curShortcutName="curShortcutName"
                :clearable="false"
                :editable="false"
                :picker-options="pickerOptions1"
                v-model="form.createTime"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy.MM.dd HH:mm"
                :disabled="!!form.mailNoList"
              ></yto-date-picker>
            </el-form-item>
            <el-form-item label="收件人姓名" prop="receiveName">
              <el-input class="y-w-200" v-model.trim="form.receiveName" placeholder="请输入收件人姓名" clearable></el-input>
            </el-form-item>
            <el-form-item label="收件人电话" prop="receiveMobile">
              <el-input class="y-w-200" v-model.trim="form.receiveMobile" placeholder="请输入收件人电话" clearable></el-input>
            </el-form-item>
            <el-form-item label="发件人姓名" prop="sendName">
              <el-input class="y-w-200" v-model.trim="form.sendName" placeholder="请输入发件人姓名" clearable></el-input>
            </el-form-item>
            <el-form-item label="发件人电话" prop="sendMobile">
              <el-input class="y-w-200" v-model.trim="form.sendMobile" placeholder="请输入发件人电话" clearable></el-input>
            </el-form-item>
            <el-form-item label="商品信息" prop="goodName">
              <el-input class="y-w-200" v-model.trim="form.goodName" placeholder="请输入商品信息" clearable></el-input>
            </el-form-item>
            <el-form-item label="备注信息" prop="remark">
              <el-input class="y-w-200" v-model.trim="form.remark" placeholder="请输入备注信息" clearable></el-input>
            </el-form-item>
            <el-form-item label="订单状态" prop="waybillStatus" v-if="curComponent != 'APPLY_ORDER'">
              <el-select :popper-append-to-body="false" class="y-w-200" v-model="form.waybillStatus" placeholder="请选择订单状态" clearable>
                <template v-for="item in waybillStatusList">
                  <el-option
                    :key="item.code"
                    v-if="!item.disable"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </template>
                <el-option v-if="curComponent == 'ALL_ORDER'" label="已取消" value="30" ></el-option>
                <el-option v-if="curComponent == 'ALL_ORDER'" label="取件失败" value="20" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="float: right">            
              <el-button icon="el-icon-search" type="primary" @click="pageChange(1)">查询</el-button>
              <el-button class="border-btn" type="button" @click="resetForm('ruleForm')">
                <i class="el-icon-refresh-left y-fc-4C84FF"></i>重置
              </el-button>
              <el-button icon="el-icon-download" class="border-btn" type="button" :disabled="exportOrderListFlag" @click="exportOrderList" v-if="curComponent=='ALL_ORDER'">导出</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="yto-table yto-ks-box ksNewOrderTable" style="padding:8px 10px;">
      <div class="y-mb-8">
        <el-button type="primary" @click="cancelFn">取消订单</el-button>
        <el-button type="primary" @click="mergeFn" v-if="curComponent=='APPLY_ORDER'">合并订单</el-button>
      </div>
      <div class="infinite-list-wrapper newCustomPrintTable " style="overflow:auto; margin-bottom: 60px;">
        <el-table ref="customOrderTable" v-loading="loading"
        v-if="tableHeight"
        :data="tbody"
        :height="tableHeight"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55"
          :selectable="selectableFn">
        </el-table-column>
        <el-table-column prop="createTime" label="下单时间" :min-width="80"></el-table-column>
        <!-- 订单号 -->
        <el-table-column prop="pickupOrderNo" label="订单号" :min-width="90">
          <template slot-scope="scope" >
            <div>{{scope.row.pickupOrderNo}}</div>
          </template>
        </el-table-column>
        <!-- 订单状态 -->
        <el-table-column prop="orderStatus" label="订单状态" :min-width="80">
          <template slot-scope="scope" >
            <div>
              <!-- 有拦截状态时，需区分拦截状态、订单状态 -->
              <span v-if="scope.row.workStatus">订单状态:</span>
              <span v-text="getStrFn(scope.row.waybillStatus, waybillStatusList)"></span>
            </div>
            <div v-if="scope.row.workStatus">
              <span>拦截状态:</span>
              <span v-text="getStrFn(scope.row.workStatus, lanjieStatusList)"></span>
            </div>
            <div v-if="scope.row.payStatus">{{scope.row.payStatus}}</div>
            <!-- 买家退费 -->
            <div v-if="scope.row.isReturnAmount == '1'">运费已退还</div>
            <!-- 取件失败时、审核订单失败时，给出取件失败或审核失败的原因 -->
            <div v-if="(scope.row.waybillStatus=='30' || scope.row.waybillStatus=='-10') && scope.row.failMsg">{{ scope.row.failMsg }}</div>
          </template>
        </el-table-column>
        <!-- 取件码 -->
        <el-table-column prop="pickupCode" label="取件码" min-width="70"></el-table-column>
        <el-table-column prop="settlementTime" label="预约取件时间" min-width="100">
          <template slot-scope="scope" >
            <div>{{scope.row.settlementTimeYear}}</div>
            <div>{{scope.row.settlementTime}}</div>
          </template>
        </el-table-column>
        <!-- 寄件人信息 -->
        <el-table-column prop="sendName" label="发件人信息" min-width="180">
          <template slot-scope="scope" >
            <div>
              <div class="address-info-style">
                <span>{{ scope.row.viewSenderAddress ? scope.row.decryptSendName : scope.row.sendName }}</span>
                <i class="el-icon-view y-ml-10 y-c-p" @click.prevent.stop="decryptAddressInfo(scope.row,scope.$index, 'sender')" v-if="scope.row.viewSenderAddress"></i>
                <img src="@/assets/images/view-no.png" class="view-img-style" @click.prevent.stop="decryptAddressInfo(scope.row,scope.$index, 'sender')" v-else/>
              </div>
              <div>
                <span>{{scope.row.viewSenderAddress ? scope.row.decryptSendMobile : scope.row.sendMobile}}</span>
                <span :class="{'y-ml-10': !!scope.row.sendMobile }">{{ scope.row.viewSenderAddress ? scope.row.decryptSendPhone : scope.row.sendPhone}}</span>
              </div>
              <div>{{scope.row.sendProvince||""}}{{ scope.row.sendCity||"" }}{{ scope.row.sendCounty||"" }}{{ scope.row.viewSenderAddress ? scope.row.decryptSendAddress : scope.row.sendAddress }}</div>
            </div>
          </template>
        </el-table-column>
        <!-- 收件人信息 -->
        <el-table-column prop="receiveName" label="收件人信息" min-width="180">
          <template slot-scope="scope" >
            <div>
              <div class="address-info-style">
                <span>{{ scope.row.viewReciverAddress ? scope.row.decryptReceiveName : scope.row.receiveName }}</span>
                <i class="el-icon-view y-ml-10 y-c-p" @click.prevent.stop="decryptAddressInfo(scope.row,scope.$index, 'reciver')" v-if="scope.row.viewReciverAddress"></i>
                <img src="@/assets/images/view-no.png" class="view-img-style" @click.prevent.stop="decryptAddressInfo(scope.row,scope.$index, 'reciver')" v-else/>
              </div>
              <div>
                <span>{{scope.row.viewReciverAddress ? scope.row.decryptReceiveMobile : scope.row.receiveMobile}}</span>
                <span :class="{'y-ml-10': !!scope.row.receiveMobile }">{{ scope.row.viewReciverAddress ? scope.row.decryptReceivePhone : scope.row.receivePhone}}</span>
              </div>
              <div>{{scope.row.receiveProvince||""}}{{ scope.row.receiveCity||"" }}{{ scope.row.receiveCounty||"" }}{{ scope.row.viewReciverAddress ? scope.row.decryptReceiveAddress : scope.row.receiveAddress }}</div>
            </div>
          </template>
        </el-table-column>
        <!-- 运单号 -->
        <el-table-column prop="waybillNo" label="运单号" min-width="150" v-if="curComponent != 'APPLY_ORDER'">
          <template slot-scope="scope" >
            <div class="y-f y-f-a">
              <div class="linkColor border-box-span">
                <span class="systemColor y-c-p" @click.prevent.stop="viewLogisticsTrack(scope.row)">{{scope.row.waybillNo}}</span>
              </div>
              <i v-if="scope.row.waybillNo" class="el-icon-document-copy" title="复制" @click.prevent.stop="copyWaybillNo(scope.row)"></i>
            </div>
          </template>
        </el-table-column>
        <!-- 备注信息 -->
        <el-table-column prop="printNum" label="打印状态" min-width="100" v-if="curComponent != 'APPLY_ORDER'">
          <template slot-scope="scope" >
            <div>{{scope.row.printNum >= 1 ? '已打印' : '未打印'}}</div>
          </template>
        </el-table-column>
        <!-- 商品信息 -->
        <el-table-column prop="goodLists" label="商品信息"  min-width="180">
          <template slot-scope="scope">
            <div v-for="(good, gidx) in (scope.row.goodLists || [])" :key="good.id + '_' + gidx">
              <el-tooltip
                v-if="good.goodName"
                class="item"
                effect="light"
                :content="good.goodName + (good.goodSpecs ? ('*'+good.goodSpecs) :'') + '*' + good.goodNum">
                <div class="y-f-multi-ell">{{ good.goodName }} {{ good.goodSpecs ? ( '* ' + good.goodSpecs ) : '' }} * {{ good.goodNum }}</div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <!-- 备注信息 -->
        <el-table-column prop="remark" label="备注信息" min-width="100">
          <template slot-scope="scope" >
            <el-tooltip
              v-if="scope.row.remark"
              class="item"
              effect="light"
              :content="scope.row.remark">
              <div class="y-f-multi-ell">{{scope.row.remark}}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column label="操作"  width="200" fixed="right">
          <template slot-scope="scope">
            <div>
              <!-- <template v-if="scope.row.waybillStatus == '-20'|| scope.row.waybillStatus == '-10'">
                <span class="systemColor y-c-p" @click="auditModifyFn(scope.row)">确认下单</span>
                <el-divider direction="vertical"></el-divider>
                <span class="systemColor y-c-p" @click="refuseFn(scope.row)">拒绝下单</span>
                <el-divider direction="vertical"></el-divider>
              </template> -->
              <template v-if="scope.row.waybillStatus == '0'">
                <span class="systemColor y-c-p" @click="modifyFn(scope.row)">修改</span>
                <el-divider direction="vertical"></el-divider>
                <span class="systemColor y-c-p" @click="cancelFn(scope.row)">取消</span>
                <el-divider direction="vertical"></el-divider>
              </template>
              <template v-if="(scope.row.waybillStatus == '10'||scope.row.waybillStatus == '50')&&scope.row.payStatus">               
                <span class="systemColor y-c-p" @click="cancelFn(scope.row)">取消</span>
                <el-divider direction="vertical"></el-divider>
              </template>              
              <!-- 订单状态 非  待取件 、已取消、 取件失败 、派件中、 已签收，已退回、待审核、拒绝下单、自动下单失败、消费者取消、自动下单已存库 且  拦截状态非 已拦截-->
              <!-- <template v-if="scope.row.waybillStatus != '0'&&scope.row.waybillStatus != '30'&&scope.row.waybillStatus != '20'&&scope.row.waybillStatus != '70'&&scope.row.waybillStatus != '90'&&scope.row.waybillStatus != '100' && scope.row.workOptStatus != '1' && scope.row.waybillStatus != '-20' && scope.row.waybillStatus != '35'&& scope.row.waybillStatus != '-10'&& scope.row.waybillStatus != '39'&& scope.row.waybillStatus != '200'">
                <span class="systemColor y-c-p" @click="lanjieFn(scope.row)">发起拦截</span>
                <el-divider direction="vertical"></el-divider>
              </template> -->
              <!-- 只有拦截状态是10 退回中 时，才可以取消拦截 -->
              <!-- <template v-if="scope.row.workStatus == '10'">
                <span class="systemColor y-c-p" @click="cancelLanjieFn(scope.row)">取消拦截</span>
                <el-divider direction="vertical"></el-divider>
              </template> -->
              <template v-if="scope.row.waybillStatus != '-20' && scope.row.waybillStatus != '-10'">
                <span class="systemColor y-c-p" @click="copyOrderFn(scope.row)" >再寄一单</span>
                <el-divider direction="vertical"></el-divider>
              </template>
              <span class="systemColor y-c-p" @click="viewDetailFn(scope.row)">详情</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginton-footer-box box-shadow-wrapper" :class="{'collapse-footer': !isCollapse}">
        <!-- 选择模板 -->
        <changeTemplate
          ref="tempRef"
          v-if="isRefreshTemplate"
          :platformCode="'SPECIALORDER'"
          :curComponent="curComponent"
          :templateAList="templateList"
          :curTemplateId="selectPrinterForm.tempId"
          @changeTemplateId="changeTemplateId"
          @addOneTemplate="isShowAddTemplateDialog=true"
          @deleteTemplate="deleteTemplate"
        ></changeTemplate>
        <div class="split-line"></div>
        <!-- 分页器 -->
        <div class="totalFooter-top y-f-a">
          <div class="y-fs-14">
            已选
            <span class="totalNumStyle" style="color: red">{{ selectData ? selectData.length : 0 }}</span>
            条记录（共
            <span class="totalNumStyle" style="color: #000">{{ total }}</span>条）
          </div>
          <div class="print-footer-medium" v-show="curComponent == 'PRINTED_ORDER'">
            <el-button icon="el-icon-refresh-right" type="primary" @click="selectPrinterForm.isOnlyApply=false;batchPrinting(true)">
              原单重打
            </el-button>
          </div>
          <div class="print-footer-medium" v-show="curComponent == 'APPLY_ORDER' || curComponent == 'ALL_ORDER'">
            <el-button type="primary" @click="selectPrinterForm.isOnlyApply=false;batchPrinting(false)">
              <svg-icon icon-class="dayin-printer" class="icon-svg-style"></svg-icon>打印快递单
            </el-button>
          </div>
          <el-pagination
            @size-change="limitChange"
            @current-change="pageChange"
            :current-page.sync="pageNo"
            :page-sizes="[100, 300, 500, 1000]"
            :page-size="limit"
            :pager-count=5
            layout="sizes, prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 物流轨迹弹层 -->
    <order-tracking-details
      :value="logisticsTrackDialog"
      v-if="logisticsTrackDialog"
      :data="logisticsTrack"
      :noWorkOrderAndRecive="true"
      @close="closeLogisticsTrackDialog"
      ref="orderTrackingDetails"
    ></order-tracking-details>
    <!-- 订单详情弹层 -->
    <orderDetail
      v-if="detailDialog"
      :isShow="detailDialog"
      :rowInfo="currentRow"
      @closeDialog="closeDetialDialog"
    ></orderDetail>
    <!-- 修改订单弹层 -->
    <modifyDialog
      v-if="modifyDialog"
      :isShow="modifyDialog"
      :rowInfo="currentRow"
      @closeDialog="closeModifyDialog"
      ref="modifyDialog"
    ></modifyDialog>
    <!-- 打印弹层校验发件人、打印组件、模板信息 -->
    <validatePrintItems
      v-if="isShowValidateDialog"
      :isShow="isShowValidateDialog"
      :senderList="[]"
      :curSenderId="selectPrinterForm.sernderId"
      :templateAList="templateList"
      :curTemplateId="selectPrinterForm.tempId"
      :step="validateStep"
      :platformType="'CUSTOM'"
      @closeValiDialog="closeValiDialog"
      @refreshOriginList="refreshOriginList"
      @addOneTemplate="addOneTemplate"
    ></validatePrintItems>
    <!-- 添加模板 -->
    <addTemplateDialog
      v-if="isShowAddTemplateDialog"
      :visible.sync="isShowAddTemplateDialog"
      :tplList="templateList"
      @showShopSetting="showShopSettingFromFaceTpl"
      :defaultCpCode="defaultCpCode"
      :defaultPlatformType="defaultPlatformType"
      :closeByConfirm="getTemplateList"
    ></addTemplateDialog>
    <!-- 打印快递单前弹层选择打印机 -->
    <el-dialog
      :title="(selectPrinterForm.isOnlyApply ? '仅获取单号' : '打印快递单')"
      width="710px"
      custom-class="ninvoiceDialog"
      class="customSelectWaybillPrinter"
      id="dialogForScan"
      :visible.sync="selectPrinterDialogVisible"
      :close-on-click-modal="false"
      :before-close="closeSelectPrinterForm"
    >
      <el-form :model="selectPrinterForm" label-width="190px" ref="resetSelectPrinterForm" :rules="selectPrinterFormRules">
        <printWarningTip :alertTitle="alertTitle" :selectPrinterForm="selectPrinterForm"></printWarningTip>
        <el-form-item label="您本次选择的打印模板是：" prop="">
          <div>
            <span>{{curTemplateInfo.tempName}}</span>
          </div>
        </el-form-item>
        <el-form-item label="快递单打印机" prop="printer">
          <span class="custom-select-style">
            <span class="systemColor" v-text="getDefautPrinter()"></span>
            <el-select
              :popper-append-to-body="false"
              v-model="selectPrinterForm.printer"
              placeholder="请选择快递单打印机"
              class="custom-select-border-style"
              :class="{
                'custom-select-style-input-default-printer':
                  getDefautPrinter() == '默认',
                'custom-select-style-input-pinter':
                  getDefautPrinter() !== '默认',
              }"
            >
              <el-option
                v-for="(item, index) in printerList"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </span>
          <span
            v-if="printerList.length"
            class="systemColor"
            style="font-size: 12px; margin-left: 5px; cursor: pointer"
            @click="setDefaultPrinter"
            >设置默认打印机</span
          >
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer align-center-box"
        style="margin-bottom: 10px"
      >
        <el-button @click="closeSelectPrinterForm">取 消</el-button>
        <el-button type="primary" @click="submitPrintForm">{{selectPrinterForm.isOnlyApply ? '仅获取单号' : '打 印'}}</el-button>
      </div>
    </el-dialog>
    <!-- 打印快递单进度 -->
    <order-print
      ref="orderPrintComponent"
      @close-print-dialog="closePrinting"
    ></order-print>
  </div>
</template>

<script>
import util from '@/utils/util';
import cnPrint from '@/utils/cainiaoPrint';
import { dateFormat, copyText, getShortcutsMap, YTOSHORTCUTS } from '@/utils/util';
import orderDetail from './components/orderDetail';
import modifyDialog from './components/modifyDialog';
import { PLATFORMNAMEMAP } from '@/utils/globalConfig';
import changeTemplate from '@/components/printValidate/changeTemplate'; // 切换打印模板
import validatePrintItems from '@/components/printValidate/validatePrintItems'; // 校验打印弹层中发件人、快递单模板、打印组件等
import addTemplateDialog from '@/views/baseInfo/printTemplate/eleFaceSheetTpl/components/addFaceTpl.vue'; // 添加模板弹层
import orderPrint from './components/orderPrint'; // 打印快递单进度
import printWarningTip from '@/components/printWarningTip/printWarningTip'; // 打印组件未识别提示语
import { userStartInterceptForRetrunPickupApi, userCancelInterceptForRetrunPickupApi, refuseOrderApi, checkCustomerOrderTimeApi, againConfirmOrderApi, confirmOrderApi, decryptUserInfoApi } from '@/api/waybillPrint/returnPickupPrint';
import { querySpecialOrderApi, cancelSpecialOrderApi, batchCancelSpecialOrderApi, mergeSpecialOrderApi, exportOrderApi } from '@/api/waybillPrint/sepecialOrderPrint';
import { getCustomerUserPrintTempListApi, updatePrintTplApi } from '@/api/universal';
export default {
  name: 'printingTable',
  components: {
    orderDetail,
    modifyDialog,
    changeTemplate, // 切换打印模板
    validatePrintItems, // 校验打印弹层中发件人、快递单模板、打印组件等
    addTemplateDialog, // 添加模板弹层
    orderPrint, // 打印快递单进度
    printWarningTip, // 打印组件未识别提示语
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    },
    isSignOrder() {
      let list = this.printData.filter(item => { return item.orderType === 1; });
      return list && list.length;
    },
    isShowRealName() {
      let host = window.location.host;
      return !host.match(/^kh.yto.net.cn/i)
    },
    isCollapse() {
      return this.$store.state.sidebar.isOpen;
    },
  },
  props: ['curComponent', 'savePrintData'],
  data() {
    return {
      exportOrderListFlag:false,
      PLATFORMNAMEMAP,
      curShortcutName: '',
      pickerOptions1: YTOSHORTCUTS,
      form: {
        mailNoList: '', // 1 下单时间 2打印订单时间
        createTime: [],
        lanjieStatus: '',
        waybillStatus: '',
        receiveName: '',
        receiveMobile: '',
        sendName: '',
        sendMobile: '',
        goodName: '',
        remark: ''
      },
      total: 0,
      pageNo: 1,
      limit: 100,
      lanjieStatusList: [
        {
          code: '',
          name: '全部',
        },
        {
          code: '10',
          name: '退回中',
        },
        {
          code: '20',
          name: '实物拦截成功',
        },
        {
          code: '30',
          name: '退回签收',
        },
        {
          code: '40',
          name: '退回失败',
        },
        {
          code: '50',
          name: '取消退回',
        },
        {
          code: 'R01',
          name: '处理中'
        },
        {
          code: 'R02',
          name: '实物拦截成功'
        },
        {
          code: 'R03',
          name: '退回签收'
        },
        {
          code: 'R04',
          name: '退回失败'
        },
        {
          code: 'R05',
          name: '取消退回'
        },
        {
          code: 'C01',
          name: '处理中'
        },
        {
          code: 'C02',
          name: '转寄中'
        },
        {
          code: 'C03',
          name: '更址签收'
        },
        {
          code: 'C04',
          name: '更址失败'
        },
        {
          code: 'C05',
          name: '取消更址'
        }
      ],
      waybillStatusList: [
        {
          code: '',
          name: '全部',
        },
        {
          code: '0',
          name: '待取件',
        },
        {
          code: '10',
          name: '已取件',
        },
        {
          code: '30',
          name: '已取消',
          disable: true,
        },
        {
          code: '20',
          name: '取件失败',
          disable: true,
        },
        {
          code: '50',
          name: '已揽收',
        },
        {
          code: '60',
          name: '运输中',
        },
        {
          code: '70',
          name: '派件中',
        },
        {
          code: '90',
          name: '已签收',
        },
        {
          code: '100',
          name: '退回中',
        },
        {
          code: '-20',
          name: '待审核',
          disable: true,
        },
        {
          code: '35',
          name: '已拒绝',
          disable: true,
        },
        {
          code: '-10',
          name: '自动下单失败',
          disable: true,
        },
        {
          code: '39',
          name: '消费者取消',
          disable: true,
        },
        {
          code: '200',
          name: '自动下单已存库',
          disable: true,
        }
      ],
      loading: false,
      tbody: [],
      screenW: null,
      screenH: null,
      tableHeight: 0,
      logisticsTrackDialog: false,
      logisticsTrack: {},
      selectData: [],
      detailDialog: false,
      currentRow: {},
      modifyDialog: false,
      selectPrinterDialogVisible: false, // 打印选择列表
      selectPrinterForm: {
        tempId: '',
        printer: '',
        waybillKcodeOgigin: '',
        platformCode: '',
        baseTempId: '',
        waybillNetOrigin: '',
        pddNetOrgin: '',
        companyId: '',
        selectMailNo: 'N',
        selectOldMailNo: '',
        cpCode: '', // 物流公司平台
        manyWayBillNum: 2, // 一单多包裹 数量
        isMultiWaybill: false, // 是否是一单多包裹
        printMethod: 'N',
        scanInput: '',
        signType: false, // 是否勾选签单返还业务
        hasYzdService: false, // 是否开启圆准达并勾选了圆准达服务
        yzdServiceChecked: false, // 是否打印圆准达面单--线上模式，实时消费
        yzdServiceMonChecked: false, // 是否打印圆准达(月结)面单--线下模式，月结消费
        localPartsType: false, // 同城件服务
        localPartsHKJType:false,//航空件服务
        realName: '', // 实名信息
        productType: 'productType', // 产品类型
      },
      selectPrinterFormRules: {
        printer: [
          { validator: (rule, value, callback) => {
            if (!value && !this.selectPrinterForm.isOnlyApply) {
              callback(new Error('不能为空'));
            } else {
              callback();
            }
          }, trigger: 'change' }
        ],
        realName: [{required: true, message: '请选择实名信息', trigger: 'change' }]
      },
      alertTitle: null,
      printerList: [], // 获取打印机列表
      isRefreshTemplate: true,
      templateList: [], // 获取打印模板列表
      isShowAddTemplateDialog: false,
      isShowValidateDialog: false,
      validateStep: null,
      onWaybillList: util.oneWaybillList, // 一联单模板
      defaultCpCode: '',
      defaultPlatformType: '',
      isRepeatPrint: false, // 是否是原单重打 true是 false 否
      printData: [], // 打印详情
      troubleList: [], // 故障列表
      addWranTipVisible: false, // 添加警告弹层
      isSinglePrint: false, // 是否是一单一包裹
      oldMailNoList: [], // 旧单号列表
      curTemplateInfo: {}, // 当前所选模板信息
      realNameList: [], //实名认证 列表
      isShowBindPrintKeyDialog: false,
      netSendInfo: null, // 线准达服务信息
      validateKcode: false, // 校验所选择的k码是否有密钥
      errMsg: '', // 校验圆准达服务是否有异常信息
      errCode: '', // 校验圆准达服务的错误码
      orderNumList: [
        { value: 2, name: 2 },
        { value: 3, name: 3 },
        { value: 4, name: 4 },
        { value: 5, name: 5 },
        { value: 6, name: 6 },
        { value: 7, name: 7 },
        { value: 8, name: 8 },
        { value: 9, name: 9 },
        { value: 10, name: 10 },
      ], // 一单多包裹 打印面单数量列表
      onWaybillList: util.oneWaybillList, // 一联单模板
      hyWaybillList: util.hwWaybillList, // 海外模板
    };
  },
  created() {
    this.initPrintCompont();
    this.init();
  },
  mounted() {
    // 单条数据打印---从新建订单页面 保存并打印 返回后打印
    if (this.savePrintData) {
      this.printing(this.savePrintData);
    }
  },
  methods: {
    // 获取打印模板
    async getTemplateList(refreshFlag) {
      // 关闭添加模板弹层
      this.isShowAddTemplateDialog = false;
      this.isShowValidateDialog = false;
      this.defaultCpCode = "";
      this.defaultPlatformType = "";
      await getCustomerUserPrintTempListApi({ loginId: this.userMess.loginId, waybillCode: 'NEWCUSTOM' }).then((res) => {
        if (res.message === 'ok') {
          let tempList = res.data || [];
          this.templateList = [];
          this.templateList = tempList.filter((item) => {
            return item.wpCode == 'YTO' && item.waybillCode == 'YTO' && item.printAccount == 'KTHJ999999';
          });
          if (refreshFlag === 'refresh') {
            // 重新设置当前所选模板信息
            this.valiBeforePrint();
          } else if (refreshFlag !== 'delete') {
            this.setDefaultTemplateList();
          }
          // 添加、删除完模板需要更新模板组件
          this.isRefreshTemplate = false;
          this.$nextTick(() => {
            this.isRefreshTemplate = true;
          });
        } else {
          this.templateList = [];
        }
      }).catch(() => {
        this.templateList = [];
      });
    },
    // 获取快递单打印模板列表
    setDefaultTemplateList() {
      this.selectPrinterForm.tempId = '';
      let localTemplateId = localStorage.getItem(`SPECIAL_templateId|${this.userMess.loginId}`);
      if (localTemplateId) {
        // 若有本地选中模板，则将本地选中模板置为模板的第一项并选中
        let index = this.templateList.findIndex(item => { return item.id === localTemplateId; });
        if (index > -1) {
          let newList = this.templateList.splice(index, 1);
          this.templateList.unshift(newList[0]);
          setTimeout(() => {
            this.$refs.tempRef.selectedTemplate(this.templateList[0])
          }, 10)
        }
      } else if (this.templateList.length) {
        let defaultTemplate = this.templateList.filter(item => { return item.isDefault === 'Y'; });
        if(defaultTemplate.length) {
          setTimeout(() => {
            this.$refs.tempRef.selectedTemplate(defaultTemplate[0])
          }, 10)
        } else {
          // 若没有默认模板，则选中第一项模板
          setTimeout(() => {
            this.$refs.tempRef.selectedTemplate(this.templateList[0])
          }, 10)
        }
      }
    },
    // 切换选中模板
    changeTemplateId(id) {
      this.selectPrinterForm.tempId = id;
      // this.$set(this.selectPrinterForm, 'tbPlatformCode', ''); // 面单类型
    },
    deleteTemplate() {
      this.selectPrinterForm.tempId = ''; // 模板id置空
      // this.$set(this.selectPrinterForm, 'tbPlatformCode', ''); // 面单类型
      this.getTemplateList('delete');
    },
    // 打印
    printing(row) {
      // 检测菜鸟组件、拼多多组件优化
      this.initPrintCompont();
      setTimeout(() => {
        this.isSinglePrint = false;
        this.printData = row;
        // 如没有打印模板，点击打印时弹出校验层
        if (!this.templateList.length) {
          this.validateStep = '2';
          this.isShowValidateDialog = true;
          return false;
        }
        // 打印前参数校验
        if (!this.selectPrinterForm.tempId) {
          this.$message.error('请在下方模板栏选择一个打印模板');
          return false;
        }
        let curTemplateList = this.templateList.filter(item => { return item.id === this.selectPrinterForm.tempId; });
        if (util.yzdWaybillList.includes(curTemplateList[0].baseTempId)) {
          this.$confirm('圆准达产品可直接使用标准一联单、二联单、三联单打印，无需单独设置模板', '提示', {
            confirmButtonText: '重新选模板打印',
            showCancelButton: false,
            type: 'warning',
            closeOnClickModal: false,
          }).then(() => {
            return false;            
          })
        } else {
          // 打印前校验
          let valieBeforeFlag = this.valiBeforePrint();
          if (!valieBeforeFlag) {
            return false;
          } else {
            // this.orderPrintDialogComponent();
            this.selectPrinterDialogVisible = true;
          }
        }
      }, 1000);
    },
    // 设置默认打印机
    setDefaultPrinter() {
      if (!this.selectPrinterForm.printer) {
        this.$refs.resetSelectPrinterForm.validateField(['printer']);
        return false;
      }
      let obj = this.curTemplateInfo;
      obj.defaultPrint = this.selectPrinterForm.printer;
      obj.defaultSendAddress = obj.defaultSendAddress || '';
      obj.userId = this.userMess.loginId;
      updatePrintTplApi(obj).then(res => {
        if (res.message === 'ok') {
          this.getDefautPrinter();
          this.getTemplateList();
        }
      });
    },
    // 获取默认打印机列表
    getDefautPrinter() {
      let str1 = '';
      if (this.selectPrinterForm.printer === this.curTemplateInfo.defaultPrint) {
        str1 = '默认';
      }
      return str1;
    },
     // 获取默认实名人
    getDefautRealName() {
      let str1 = '';
      if (this.realNameList.length) {
        // 本地存储的K码实名信息
        let defaultRealName = localStorage.getItem(`CUSTOM_NEW_default_realName|${this.userMess.loginId}|${this.curTemplateInfo.printAccount}`);
        let nameInfo = defaultRealName ? defaultRealName.split('|') : ['', ''];
        // 查询本地存储的K码实名信息在当前列表中不存在，则默认为列表的第一个实名信息
        let isExistLocal = this.realNameList.findIndex(o => { return (o.agentCertificatesName == nameInfo[0] && o.agentRealId == nameInfo[1])});
        let defaultInfo = isExistLocal > -1 ? defaultRealName :  (this.realNameList[0].agentCertificatesName + '|' + this.realNameList[0].agentRealId);
        if (this.selectPrinterForm.realName === defaultInfo) {
          str1 = '默认';
        }
      }
      return str1;
    },
    // 关闭打印弹层
    closePrinting() {
      this.curTemplateInfo = {};
      this.closeSelectPrinterForm();
      this.getOrders();
    },
    // 批量打印-快递单
    batchPrinting(flag, row) {
      if (row) {
        this.selectData = [row];
      }
      if (!this.selectData.length) {
        this.$confirm('请勾选您要打印的订单', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false,
          closeOnClickModal: false,
        }).then(() => {});
        return false;
      }
      // let newList = this.selectData.filter(item => item.waybillStatus !== '0');
      // if (newList.length > 0) {
      //   this.$message.error('您选择的订单中包含非待取件的订单，请重新选择！');
      //   return false;
      // }
      // 如没有打印模板，点击打印时弹出校验层
      if (!this.templateList.length) {
        this.validateStep = '2';
        this.isShowValidateDialog = true;
        return false;
      }
      // 打印前参数校验
      if (!this.selectPrinterForm.tempId) {
        this.$message.error('请在下方模板栏选择一个打印模板');
        return false;
      }
      // 检测菜鸟组件
      this.initPrintCompont();
      // 打印前校验
      let valieBeforeFlag = this.valiBeforePrint();
      if (!valieBeforeFlag) {
        return false;
      }
      this.isRepeatPrint = flag;
      this.printData = JSON.parse(JSON.stringify(this.selectData));
      this.selectPrinterForm.selectMailNo = 'N';
      this.selectPrinterDialogVisible = true;
      // this.orderPrintDialogComponent();     
    },
    // 打印前校验
    valiBeforePrint() {
      this.selectPrinterForm.printer = '';
      // 获取模板信息
      this.curTemplateInfo = {};
      this.templateList.forEach(item => {
        if (item.id == this.selectPrinterForm.tempId) {
          this.$set(this.selectPrinterForm, 'platformCode', item.waybillCode);
          this.$set(this.selectPrinterForm, 'baseTempId', item.baseTempId);
          this.$set(this.selectPrinterForm, 'cpCode', item.wpCode); // 模板对应的物流公司类型
          // this.$set(this.selectPrinterForm, 'tbPlatformCode', ''); // 面单类型
          // 获取模板中设置的默认发件人
          // if (item.defaultSendAddress) {
          //   this.selectPrinterForm.sernderId = item.defaultSendAddress;
          // }
          // 获取模板中设置的默认打印机
          if (item.defaultPrint) {
            let printer = this.printerList.filter(cnItem => { return cnItem.name === item.defaultPrint; });
            this.selectPrinterForm.printer = printer.length ? printer[0].name : '';
          }
          
          this.curTemplateInfo = item;
        }
      });
      // 校验打印组件是否开启--菜鸟
      if (this.alertTitle) {
        this.validateStep = '3';
        this.isShowValidateDialog = true;
        return false;
      }
      return true;
    },
    // 关闭打印前校验弹层
    closeValiDialog(str) {
      this.isShowValidateDialog = false;
      if (str === 'ok') {
        // 检测菜鸟组件、拼多多组件优化
        this.initPrintCompont();
        this.$nextTick(() => {
          // this.orderPrintDialogComponent();
          this.selectPrinterDialogVisible = true;
        });
      } else {
        this.closeSelectPrinterForm();
      }
    },
    // 重新设置单号源后查询模板列表
    refreshOriginList() {
      // 重新设置当前所选模板信息
      this.getTemplateList('refresh');
    },
    // 如果没有模板，点击立即设置，打开添加模板弹层，并定位到当前平台的圆通模板
    addOneTemplate(params) {
      if (params) {
        this.defaultCpCode = 'YTO';
        this.defaultPlatformType = params.openPlatformType || 'YTO';
      }
      this.isShowAddTemplateDialog=true;
    },
    showShopSettingFromFaceTpl(val) {
      // 添加电子面单模板拉起设置默认店铺弹窗
      this.curRowInfo = JSON.parse(val); // 这里单独处理一下tempId
      this.isShowShopSetting = true;
    },
    // 提交选择打印机弹层
    async submitPrintForm(typeStr) {
      this.$refs['resetSelectPrinterForm'].validate((valid) => {
        if (!valid) {
          return false;
        }
        
        if (this.selectPrinterForm.isMultiWaybill && this.printData.length > 500) {
          this.$message.error('一单多包裹面单最多可选500条订单!');
          return false;
        }
        
        localStorage.setItem(`SPECIAL_templateId|${this.userMess.loginId}`, this.selectPrinterForm.tempId);
        this.orderPrintDialogComponent();
        // this.closeSelectPrinterForm();
      });
    },
    // 打印弹层子组件
    orderPrintDialogComponent() {
      // 全局定义批次
      let date = dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss');
      let dateStr = date.replace(/[- :]/g, '').substring(2, 14);
      let printBatch = `${dateStr}01${util.getUUID(4, 10)}`;
      // 打印进度层显示
      this.orderPrintVisible = true;
      this.$refs.orderPrintComponent.printBatch = printBatch;
      this.$refs.orderPrintComponent.data = JSON.parse(JSON.stringify(this.printData));
      this.$refs.orderPrintComponent.tempInfo = JSON.parse(JSON.stringify(this.curTemplateInfo));
      this.$refs.orderPrintComponent.selectPrinterForm = JSON.parse(JSON.stringify(this.selectPrinterForm));
      this.$refs.orderPrintComponent.printerIndex = this.selectPrinterForm.printer;
      this.$refs.orderPrintComponent.init(); // 调用打印子组件
    },
    // 关闭选择打印机弹层
    closeSelectPrinterForm() {
      if (this.savePrintData) {
        this.$emit('getPrintData', null)
      }
      this.resetForm('resetSelectPrinterForm');
      this.selectPrinterDialogVisible = false;
      this.selectPrinterForm.manyWayBillNum = 2;
      this.selectPrinterForm.isMultiWaybill = false;
      this.errMsg = '';
      this.errCode = '';
      this.selectPrinterForm.printMethod = 'N';
      this.selectPrinterForm.scanInput = '';
      this.printData = [];
      this.scanOrderList = [];
      this.selectPrinterForm.signType = false;
      this.selectPrinterForm.isOnlyApply = '';
      this.isShowValidateDialog = false;
      this.orderPrintVisible = false;
      this.selectPrinterForm.localPartsType = false;
      this.selectPrinterForm.localPartsHKJType = false;
    },
    exportOrderList(){
      let query = {
        goodName: this.form.goodName.trim(),
        remark: this.form.remark.trim(),
        workStatus: this.form.lanjieStatus,
        waybillStatus: this.form.waybillStatus,
        pageNumber: this.pageNo,
        pageSize: this.limit,
        waybillList: [],
        queryType:  '',
        receiveName: this.form.receiveName || '',
        receiveMobile: this.form.receiveMobile || '',
        sendName: this.form.sendName || '',
        sendMobile: this.form.sendMobile || '',
      };
      if (this.curComponent == 'APPLY_ORDER') {
        query.queryType = '0';
      } else if (this.curComponent == 'PRINTED_ORDER') {
        query.queryType = '1';
      } else if (this.curComponent == 'CANCEL_ORDER') {
        query.queryType = '-1';
      } else if (this.curComponent == 'ALL_ORDER') {
        query.queryType = '2';
      }
      if(this.form.mailNoList) {
        let mailNos = [];
        let arr =  this.form.mailNoList ? this.form.mailNoList.split(/[(\r\n)\r\n]+/) : [];
        let arr1 = [];
        arr.forEach(r => {
          arr1.push(r.split(','));
        });
        arr1 = [].concat(...arr1);
        arr.length = 0;
        arr1.forEach(t => {
          arr.push(t.split('，'));
        });
        arr = [].concat(...arr);
        mailNos = arr.filter(item => item && item.trim());
        let waybillList = [];
        mailNos.forEach(r => {
          if (r) {
            r = r.replace(/\s+/g, '');// 去所有空格
           waybillList.push(r);
          }
        });
        query.waybillList = waybillList;
      }
      if (query.waybillList.length > 100) {
        this.$message.error('单号最多可输入100个');
        return false;
      }
      // 单号查询时，不带时间范围
      if (this.form.createTime && this.form.createTime.length > 0 && !query.waybillList.length) {
        query.beginDate = this.form.createTime[0];
        query.endDate = this.form.createTime[1];
      }else{
        query.beginDate = '';
        query.endDate = '';
      }
      this.exportOrderListFlag = true;
      exportOrderApi(query).then(res=>{
        if(res.success){
          this.$alert(res.message, '提示', {
            confirmButtonText: '前往下载中心',
            type: 'warning',
            center: true
          }).then(() => {
            this.$router.push('/dataCenter/downloadCenter');
          });          
        }else{
          this.$message.error(res.message || '获取数据失败，请稍候重试');
        }
      }).finally(()=>{
        this.exportOrderListFlag = false;
      })
    },
    // 打印组件初始化
    initPrintCompont() {
      // 检测菜鸟组件
      if ( !cnPrint.taobaoWebsocket || cnPrint.taobaoWebsocket.readyState == WebSocket.CLOSED ) {
        cnPrint.getPrinterList();
        this.getPrinterList();
      } else if (cnPrint.taobaoWebsocket) {
        this.getPrinterList();
      }
    },
    // 页面初始化
    async init() {
      // 初始化搜索条件中的时间
      this.initTime();
      // 获取当前分辩率宽度
      this.screenW = window.screen.width || document.body.clientWidth;
      // 获取当前分辨率高度
      this.screenH = document.documentElement.clientHeight; // 页面整体的高度
      this.tableHeight = this.screenH - 300;
      // 查询打印列表
      this.getOrders();
      // 获取打印模板列表
      await this.getTemplateList();
      // 获取打印机列表
      this.getPrinterList();
      
    },
    // 初始化时间
    initTime() {
      let createTime = [];
      let agoDays = '';
      if(localStorage.getItem(`custom_sepecial_${this.curComponent}_customrange`)) {
        let customrange = JSON.parse(localStorage.getItem(`custom_sepecial_${this.curComponent}_customrange`));
        agoDays = new Date(new Date().getTime() - customrange.dateRange * 24 * 3600 * 1000);
        this.curShortcutName = customrange.curShortcutName;
        if(this.curShortcutName === 'customRange') {
          // 只有是记住天数选项才使用记住的那个天数时间
          createTime = [
            `${dateFormat(agoDays, 'yyyy-MM-dd')} 00:00:00`,
            `${dateFormat(new Date(), 'yyyy-MM-dd')} 23:59:59`
          ]
        } else {
          let shortcutsMap = getShortcutsMap()
          createTime = shortcutsMap[this.curShortcutName];
        }
        this.$set(this.form, 'createTime', createTime);
      } else {
        agoDays = new Date(new Date().getTime() - 2 * 24 * 3600 * 1000);
        // 初始化下单日期
        createTime = [
          `${dateFormat(agoDays, 'yyyy-MM-dd')} 00:00:00`,
          `${dateFormat(new Date(), 'yyyy-MM-dd')} 23:59:59`
        ];
        this.$set(this.form, 'createTime', createTime);
      }
    },
    // 获取打印机列表
    getPrinterList() {
      setTimeout(() => {
        this.alertTitle = cnPrint.printerObj.alertTitle;
        this.printerList = cnPrint.printerObj.printerList || [];
      }, 500);
    },
    getStrFn(status, list) {
      let newList = list.filter(o => { return o.code == status; });
      return newList.length > 0 ? newList[0].name : '';
    },
    handleSelectionChange(val) {
      this.selectData = val;
    },
    auditModifyFn(row) {
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)',
      });
      let params = {
        pickupOrderNo: row.pickupOrderNo
      };
      checkCustomerOrderTimeApi(params).then(res => {
        if (!res.success) {
          loadingMask.close();
          this.modifyDialog = true;
          this.currentRow = JSON.parse(JSON.stringify({...row, editStatus: 'auditEdit'}));
        } else {
          let params = {
            pickupOrderNo: row.pickupOrderNo
          };
          let apiUrlFn = row.waybillStatus == '-10' ? againConfirmOrderApi : confirmOrderApi;
          apiUrlFn(params).then(res => {
            loadingMask.close();
            if (res.success && res.data ) {
              this.$message.success('审核通过');
              this.getOrders();
            } else {
              this.$message.error(res.message || res.data.failMsg || '审核失败')
              this.getOrders();
            }
          }).catch((err)=>{
            loadingMask.close();
            this.$message.error(err.message || '网络异常，请稍候重试')
          })
        }
      }).catch(err => {
        loadingMask.close();
        this.$message.error(err.message || '网络异常，请稍候重试')
      })
    },
    // 修改订单
    modifyFn(row) {
      this.modifyDialog = true;
      this.currentRow = JSON.parse(JSON.stringify({...row, editStatus: 'edit'}));
    },
    closeModifyDialog(refresh) {
      this.modifyDialog = false;
      this.currentRow = {};
      if (refresh == 'refresh') {
        this.getOrders();
      }
    },
    // 拒绝订单
    refuseFn(row) {
      this.$confirm('您确定要拒绝此订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          pickupOrderNo: row.pickupOrderNo
        }
        let loadingMask = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)',
        });
        refuseOrderApi(params).then(res => {
          loadingMask.close();
          if (res.success && res.data) {
            this.$message.success('操作成功');
            this.getOrders();
          } else {
            this.$message.error(res.message || '操作失败');
          }
        }).catch((err)=>{
          loadingMask.close();
          this.$message.error(err.message || '网络异常，请稍候重试');
        })
      })
    },
    // 取消订单
    cancelFn(row) {
      let apiUrlFn ='';
      let params = {};
      if (row && row.id) {
        params = [{
          cancelChannel: 'channel_khgj',
          cancelReason: '客户管家取消',
          pickupOrderNo: row.pickupOrderNo,
          waybillNo: row.waybillNo,
          staffNo: '', // row.staffNo,
          userId: 'f69314be714d4aa4b9281ddecc7aff2d'
        }];
        // apiUrlFn = cancelSpecialOrderApi;
      } else {
        if (!this.selectData.length) {
          this.$confirm('请选择您要取消的订单', '', {
            confirmButtonText: '确定',
            type: 'warning',
            showCancelButton: false,
            closeOnClickModal: false
          }).then(() => {}).catch(() => {
            return false;
          });
          return false;
        }
        // apiUrlFn = batchCancelSpecialOrderApi;
        let list = JSON.parse(JSON.stringify(this.selectData));
        // 过滤数据，只有待取件的，可以取消
        list = list.filter(o => {
          return o.waybillStatus == '0'||((o.waybillStatus == '10'||o.waybillStatus == '50')&&o.payStatus);
        })
        if (!list.length) {
          this.$message({
            message: '请选择待取件状态的订单',
            type: 'warning',
            showCancelButton: false,
            closeOnClickModal: false
          }).then(() => {}).catch(() => {
            return false;
          });
          return false;
        }
        params = list.map(o => {
          return  {
            cancelChannel: 'channel_khgj',
            cancelReason: '客户管家批量取消',
            pickupOrderNo: o.pickupOrderNo,
            waybillNo: o.waybillNo,
            staffNo: '', // o.staffNo,
            userId: 'f69314be714d4aa4b9281ddecc7aff2d'
          }
        })
      }
      this.$confirm('您确定要取消订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 这里调用 接口取消订单....
        let loadingMask = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)',
        });
        batchCancelSpecialOrderApi(params).then(res => { 
          loadingMask.close();
          if (res.success && res.data) {
            let failList = res.data.fail || [];
            if (failList.length) {
              let tempHtml = '';
              failList.forEach(t => {
                tempHtml += `<div>${t.pickupOrderNo}: ${t.message}</div>`;
              })
              this.$confirm(tempHtml, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                type: 'warning'
              }).then(() => {
                this.getOrders();
              })
            } else {
              this.$message({
                message: '取消成功',
                type: 'success'
              });
              this.getOrders();
            }
          } else {
            this.$message.error(res.message || res.data.failMsg || '取消失败');
          }
        }).catch(err => {
          loadingMask.close();
          this.$message.error(err.message || '网络异常，请稍候重试');
        });
      });
    },
    // 合并订单
    mergeFn() {
      if (!this.selectData.length || this.selectData.length < 2) {
        this.$confirm('请至少选择2个要合并的订单', '', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false,
          closeOnClickModal: false
        }).then(() => {}).catch(() => {
          return false;
        });
        return false;
      }
      if (this.selectData.length > 10) {
        this.$confirm('最多只能合并10个订单', '', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false,
          closeOnClickModal: false
        }).then(() => {}).catch(() => {
          return false;
        });
        return false;
      }
      let list = this.selectData.map(t => { return `${t.sendAddressMd5}_${t.receiveAddressMd5}`});
      list = [...new Set(list)];
      if (list.length > 1) {
        this.$confirm('您选择的订单中收发件地址不一致的，不能合单，请重新选择！', '', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false,
          closeOnClickModal: false
        }).then(() => {}).catch(() => {
          return false;
        });
        return false;
      }
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)',
      });
      let parmas = {
        pickUpOrderNoList: this.selectData.map(o => o.pickupOrderNo)
      };
      mergeSpecialOrderApi(parmas).then(res => {
        loadingMask.close();
        if (res.success && res.data) {
          let list = res.data.errorMsgList || [];
          if (res.data.success && !list.length) {
            this.$message.success('合并成功');
            this.getOrders();
          } else {
            // 提示失败信息
            let errStr = '';
            list.forEach(item => {
              errStr += `<div class="y-mb-10">${item.pickupOrderNo}: ${item.failMsg || ''}</div>`
            });
            let configParams = {
              dangerouslyUseHTMLString: true,
              customClass: 'y-w-500',
              confirmButtonText: '确定',
              // cancelButtonText: '取消',
              type: 'warning'
            }
            this.$alert(errStr, '提示', configParams).then(() => {
              // 完成后，刷新列表
              this.pageChange(1);
            })
          }
          
        } else {
          this.$message.error(res.data ?.failMsg || res.message || '合并失败');
        }
      }).catch(() => {
        loadingMask.close();
        this.$message.error(err.message || '网络异常，请稍候重试');
      })
    },
    // 拦截
    lanjieFn(row) {
      this.$confirm('您确定要拦截该订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 这里调用 接口取消订单....
        let loadingMask = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)',
        });
        let params = {
          cancelChannel: 'channel_khgj',
          pickupOrderNo: row.pickupOrderNo,
          waybillNo: row.waybillNo,
          sendName: row.sendName,
          userId: 'f69314be714d4aa4b9281ddecc7aff2d'
        };
        userStartInterceptForRetrunPickupApi(params).then(res => { 
          loadingMask.close();
          if (res.success && res.data && res.data.success) {
            this.$message.success('拦截成功');
            this.getOrders();
          } else {
            this.$message.error(res.data ?.failMsg || res.message || '拦截失败');
          }
        }).catch(err => {
          loadingMask.close();
          this.$message.error(err.message || '网络异常，请稍候重试');
        });
      });
    },
    // 取消拦截
    cancelLanjieFn(row) {
      this.$confirm('您确定要取消拦截该订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 这里调用 接口取消订单....
        let loadingMask = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)',
        });
        let params = {
          cancelChannel: 'channel_khgj',
          pickupOrderNo: row.pickupOrderNo,
          waybillNo: row.waybillNo,
          sendName: row.sendName,
          userId: 'f69314be714d4aa4b9281ddecc7aff2d'
        };
        userCancelInterceptForRetrunPickupApi(params).then(res => { 
          loadingMask.close();
          if (res.success && res.data && res.data.success) {
            this.$message.success('取消拦截成功');
            this.getOrders();
          } else {
            this.$message.error(res.message || res.data.failMsg || '取消失败');
          }
        }).catch(err => {
          loadingMask.close();
          this.$message.error(err.message || '网络异常，请稍候重试');
        });
      });
    },
    // 详情
    viewDetailFn(row) {
      this.detailDialog = true;
      this.currentRow = row;
    },
    closeDetialDialog() {
      this.detailDialog = false;
      this.currentRow = {};
    },
    // 再寄一单
    copyOrderFn(row) {
      let rowInfo = JSON.parse(JSON.stringify(row));
      this.$emit('copyOrder', rowInfo);
    },
    // 物流轨迹
    viewLogisticsTrack(row) {
      this.logisticsTrack = {
        code: row.waybillNo, // 运单号
        singBkMailNo: '', // 签单返还子单 运单号
        title: '走件详情', // dialog头部标题
        isComplaint: false, // 是否为客户投诉模块
      };
      this.logisticsTrackDialog = true;
    },
    // 关闭物流轨迹
    closeLogisticsTrackDialog() {
      this.logisticsTrack = {};
      this.logisticsTrackDialog = false;
    },
    // 复制运单号信息
    copyWaybillNo(row) {
      copyText(row.waybillNo);
    },
    // 每页条数改变
    limitChange(limit) {
      this.startIndex = 0;
      this.limit = limit;
      this.pageNo = 1;
      this.checkAll = false;
      this.isIndeterminate = false;
      this.selectData = [];
      // this.dom.scrollTop = 0;
      this.getOrders();
    },
    // 页码改变
    pageChange(page) {
      this.startIndex = 0;
      this.pageNo = page;      
      this.getOrders();
    },
    // 获取订单数据，注入表格
    getOrders() {
      let query = {
        goodName: this.form.goodName.trim(),
        remark: this.form.remark.trim(),
        workStatus: this.form.lanjieStatus,
        waybillStatus: this.form.waybillStatus,
        pageNumber: this.pageNo,
        pageSize: this.limit,
        waybillList: [],
        queryType:  '',
        receiveName: this.form.receiveName || '',
        receiveMobile: this.form.receiveMobile || '',
        sendName: this.form.sendName || '',
        sendMobile: this.form.sendMobile || '',
      };
      if (this.curComponent == 'APPLY_ORDER') {
        query.queryType = '0';
      } else if (this.curComponent == 'PRINTED_ORDER') {
        query.queryType = '1';
      } else if (this.curComponent == 'CANCEL_ORDER') {
        query.queryType = '-1';
      } else if (this.curComponent == 'ALL_ORDER') {
        query.queryType = '2';
      }
      if(this.form.mailNoList) {
        let mailNos = [];
        let arr =  this.form.mailNoList ? this.form.mailNoList.split(/[(\r\n)\r\n]+/) : [];
        let arr1 = [];
        arr.forEach(r => {
          arr1.push(r.split(','));
        });
        arr1 = [].concat(...arr1);
        arr.length = 0;
        arr1.forEach(t => {
          arr.push(t.split('，'));
        });
        arr = [].concat(...arr);
        mailNos = arr.filter(item => item && item.trim());
        let waybillList = [];
        mailNos.forEach(r => {
          if (r) {
            r = r.replace(/\s+/g, '');// 去所有空格
           waybillList.push(r);
          }
        });
        query.waybillList = waybillList;
      }
      if (query.waybillList.length > 100) {
        this.$message.error('单号最多可输入100个');
        return false;
      }
      // 单号查询时，不带时间范围
      if (this.form.createTime && this.form.createTime.length > 0 && !query.waybillList.length) {
        query.beginDate = this.form.createTime[0];
        query.endDate = this.form.createTime[1];
      }else{
        query.beginDate = '';
        query.endDate = '';
      }
      this.loading = true;
      querySpecialOrderApi(query).then((res) => {
        if (res.success && res.data) {
          this.tbody = res.data.lists || [];
          this.total = res.data.total || 0;
          this.tbody.forEach(item => { 

            this.$set(item, 'viewSenderAddress', false);
            this.$set(item, 'viewReciverAddress', false);

            if (item.pickupStartTime && item.pickupEndTime) {
              item.settlementTimeYear = `${item.pickupStartTime.substring(0, 10)}`;
              item.settlementTime = `${item.pickupStartTime.substring(11, 16)}-${item.pickupEndTime.substring(11, 16)}`;
            }
          });
        } else {
          this.tbody = [];
          this.total = 0;
          this.$message.error(res.error || res.message || '获取数据失败');
        }
        this.loading = false;
      }).catch((err) => {
        this.tbody = [];
        this.total = 0;
        this.loading = false;
        this.$message.error(err.error || err.message || '网络异常，请稍候重试');
      });
    },
    // 重置按钮
    resetForm(formName) {
      this.$refs[formName] && this.$refs[formName].resetFields();
      this.initTime();
      this.$nextTick(()=>{
        this.pageChange(1);
      })
    },
    selectableFn(row) {
      return row.waybillStatus == '0'||((row.waybillStatus == '10'||row.waybillStatus == '50')&&row.payStatus)
    },
    goPlatformDetail(row) {
      if (!row.mallCode) {
        return false;
      }
      // 平台订单号跳转电商后台订单详情
      switch(row.mallPlatform) {
        case 'PDD':
          window.open('https://mms.pinduoduo.com/orders/detail?type=4399&sn=' + row.mallOrderNo, '_blank');
          break;
        case 'KS':
          window.open('https://s.kwaixiaodian.com/zone/order/detail?id=' + row.mallOrderNo, '_blank');
          break;
        case 'LUBAN':
          window.open('https://fxg.jinritemai.com/ffa/morder/order/detail-v2?id=' + row.mallOrderNo, '_blank');
          break;
        case 'JD':
          window.open('https://neworder.shop.jd.com/order/orderDetail?orderId=' + row.mallOrderNo, '_blank');
          break;
        case 'TAOBAO':
          window.open('https://trade.taobao.com/trade/detail/trade_order_detail.htm?biz_order_id=' + row.mallOrderNo, '_blank');
          break;
        case 'ALI_1688':
          window.open('https://trade.1688.com/order/new_step_order_detail.htm?orderId=' + row.mallOrderNo, '_blank');
          break;
        case 'XIAOHS':
          window.open('https://ark.xiaohongshu.com/app-order/order/detail/' + row.mallOrderNo, '_blank');
          break;          
        default:
          break;
      }
    },
    // 解密收寄件人信息详情
    decryptAddressInfo(row,index, type) {
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)',
      });
      decryptUserInfoApi({...row, decryptType: type=='sender' ? '1' : '2'}).then(res => {
        loadingMask.close();
        if (res.success && res.data) {
          this.setRowInfoFn(row,index, type, res.data);
        } else {
          this.setRowInfoFn(row,index, type, {});
          this.$message.error(res.message || '解密失败');
        }
      }).catch((err) => {
        loadingMask.close();
        this.setRowInfoFn(row,index, type, {});
        this.$message.error(res.message || '解密失败');
      })
    },
    // 设置行信息
    setRowInfoFn(row,index, type, data) {
      if (type == 'sender') {
        this.$set(this.tbody[index], 'decryptSendName', data.sendName || ''); // 加密手机号
        this.$set(this.tbody[index], 'decryptSendMobile', data.sendMobile || ''); // 加密手机号
        this.$set(this.tbody[index], 'decryptSendPhone', data.sendPhone || ''); // 加密电话
        this.$set(this.tbody[index], 'decryptSendAddress', data.sendAddress || ''); // 加密详细地址
        this.$set(this.tbody[index], 'viewSenderAddress', !row.viewSenderAddress);
      } else {
        this.$set(this.tbody[index], 'decryptReceiveName', data.receiveName || ''); // 加密手机号
        this.$set(this.tbody[index], 'decryptReceiveMobile', data.receiveMobile || ''); // 加密手机号
        this.$set(this.tbody[index], 'decryptReceivePhone', data.receivePhone || ''); // 加密电话
        this.$set(this.tbody[index], 'decryptReceiveAddress', data.receiveAddress || ''); // 加密详细地址
        this.$set(this.tbody[index], 'viewReciverAddress', !row.viewReciverAddress);
      }
      this.tbody = [...this.tbody];
    }
  },
};
</script>
<style lang="scss" scoped>
@import "../../../styles/variables";
.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.textarea-style{
    /deep/ .el-form-item__content {
      width: 380px;
    }
    .el-textarea{
      width: 380px;
    }
  }

  #nPrintingPageTable {
  
  /deep/ .el-popover__reference-wrapper {
    display: flex;
    align-items: center;
  }
  background-color: #e4e7ed;
  .el-table .cell.filter-sytle {
    position: relative;
    .showFilterDilaog {
      position: absolute;
    }
  }
  .el-table .cell {
    .custom-table-list-svg {
      vertical-align: middle;
    }
    .system-red-color {
      color: $red;
    }
    .elli {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .linkColor {
      color: $blue-style;
      cursor: pointer;
    }
    .grayColor {
      color: #999;
    }
  }
  .el-radio-group {
    .el-radio {
      height: 32px;
      line-height: 32px;
    }
  }
}
.el-dialog.ninvoiceDialog .el-select .el-input--suffix {
  width: 320px;
}
.el-icon-document-copy {
  margin-left: 5px;
  font-size: 10px;
  color: $blue-style;
  cursor: pointer;
}
.y-mb-8 {
  margin-bottom: 8px;
}
</style>
